function t(id, variables) {
  var keywords = id.split('.');
  var text = window.CultureAmp.currentTranslations;

  for (var i = 0; i < keywords.length; i++) {
    text = text[keywords[i]];
    if (text === null) {
      throw new Error("Couldn't resolve translation string " + id);
    }
  }

  for (var key in variables) {
    var regex = RegExp('%{' + key + '}', 'g');
    text = text.replace(regex, variables[key]);
  }
  return text;
}

module.exports = t;
